import fetchCountryList from './fetchCountryList';

export default fetchCountryList;
